<template>
  <div class="render">
    <v-breadcrumbs class="bc" v-if="!if_main" :items="breadcrumbs" large>
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          @click="returnMain"
          :disabled="item.disabled"
        > 
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
<div class="top d-flex align-center justify-space-between">
  <div class="d-flex align-center">
    <h1 class="mb-0">{{ current.title }}</h1>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          small
          color="grey"
          class="ml-2 info-icon"
          v-bind="attrs"
          v-on="on"
        >
          mdi-information-outline
        </v-icon>
      </template>
      <span>
        Номер по&nbsp;умолчанию хранится в&nbsp;базе&nbsp;30&nbsp;дней.<br>
        Чтобы изменить срок, отредактируйте базу и&nbsp;измените настройки автоудаления.
      </span>
    </v-tooltip>
  </div>
  <div class="d-flex align-center">
    <CreateBase
      v-if="if_main"
      :lead_type="tablist"
      :callback_refresh="renderBases"
      :groups="groups"
      type="addGroup"
      class="custom-button"
    />
    <CreateBase
      v-if="if_main"
      type="create"
      :groups="groups"
      :callback_refresh="renderBases"
    />
    <CreateBase
      v-if="!if_main"
      :lead_type="tablist"
      :guid="id"
      :callback_refresh="renderBases"
      type="add"
    />
  </div>

</div>

    <div class="content_table">
      <FilterCustom v-if="if_main"
      rangePlaceholder="Выберите дату"
      :page_type="'bases_main'"
      :showPeriod="true"
      :hideExport="true"
      :hideTime="true"
      :selects="baseSelects"
      @updateFilter="renderBases"
       />
      <Table v-if="if_main"
        :page_type="'base_main'"
        :callback_delete="deleteBase"
        :items="action_items"
        :loading="loading"
        :perPage="perPage"
        :server="false"
        :callback_refresh="renderBases"

        @delete="deleteBase"
        @edit="editBaseEmit"
        @view="viewBase"
        @export="openExportModal"


        :callback_edit="editBase"
        :callback_view="viewBase"
        :callback_export="openExportModal"

        :headers="cases.main.headers"
        :data="cases.main.data"
        :allGuids="allGuids"
        @need-ids="loadAllIds"
      />
      <div v-else>
        <v-tabs
          class="tabs_table_inner"
          v-model="tab"
          align-with-title
        >
          <v-tabs-slider color="#4B5EFF"></v-tabs-slider>
          <v-tab class="item_tab" active-class="active_tab" v-for="item in tabs" @click="tablist=item.id" :key="item.id">{{ item.name }}</v-tab>
        </v-tabs>
      </div>

      <v-tabs-items class="actions" v-model="tab" v-if="!if_main">
        <v-tab-item v-for="item in tabs" :key="item.id">
          <Table
            :page_type="item.page_type"
            :loading="loading"
            :server="true"
            :perPage="perPage"
            :items="action_items_server"
            :headers="cases[item.id].headers"
            :pageCount_server="cases[item.id].pageCount_server"

            @deletelead="deleteLead"

            :callback_edit="editBase"
            :callback_view="viewBase"
            :callback_refresh="renderBases"
            :data="cases[item.id].data"
            :allGuids="allGuids"
            @need-ids="loadAllIds"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
    <EditBase :edit_base="edit_base" :show_dialog="edit_popup" :edit_callback="editBase" :groups="groups"/>
    <ExportBase :show.sync="showExport" :guid="exportGuid" />

  </div>
</template>
<script>

import Table from '../components/Table/DataTable.vue'
import ExportBase from "@/components/Modal/Bases/ExportBase.vue";
import EditBase from '../components/Modal/Bases/EditBase.vue'
import CreateBase from '../components/Modal/Bases/CreateBase.vue'
import FilterCustom from '../components/Filter/ReportsFilter.vue'
export default {
  components: {
    Table, CreateBase,EditBase, ExportBase , FilterCustom
  },
  data(){
    return {
      basesAll:[],
      baseSelects: { baseNames: [] },
      showExport: false,
      exportGuid: null,
      groups: [],
      if_main: true,
      filters:{},
      loading:true,
      perPage:10,
      tablist:"all",
      edit_popup:false,
      edit_base:{
        id:0,
        item:{}
      },
      breadcrumbs: [
        {
          text: 'Базы номеров',
          disabled: false,
          click:'index'
        },
        {
          text: 'Link 2',
          disabled: true,
          click: false,
        }
      ],
      current: {
        title: ''
      },
      default: {
        title: 'Базы номеров'
      },
      detail: {
        title: 'Какая то база номеров A1'
      },
      tabs: [ {id:'all',name:'Все номера',page_type:'base_phones'}, {id:'black',name:'Чёрный список',page_type:'base_black'}],
      tab: null,
      action_items: [
          {title: 'Редактировать',action:'edit'},
          {title: 'Посмотреть номера',action:'view'},
          {title: 'Экспорт',action:'export'},
          {title: 'Удалить',action:'delete'},
        ],
      action_items_server: [
          {title: 'Удалить',action:'deletelead'},
        ],
      cases: {
        main: {
          data: [],
          headers: [
            { text: '№', align: 'start', value: 'id' },
            { text: 'id',  value: 'guid' },
            { text: 'Название', value: 'name' },
            { text: 'Название группы', value: 'groupName' },
            { text: 'Количество номеров', value: 'count' },
            { text: 'Чёрный список',value: 'blacklist_count'},
            { text: 'Удаление дубликатов', value: 'unique' },
            
            { text: 'Дата создания', value: 'created_at' },
            { text: 'Действия', value: 'actions', sortable: false }
          ]
        },
        'all': {
          data: [],
          pageCount_server:0,
          headers: [
            { text: '№', align: 'start', value: 'id', sortable: false },
            { text: 'Номер', value: 'phone' },
            { text: 'Дата создания', value: 'created_at' },
            { text: 'Оператор', value: 'operator' },
            { text: 'Регион', value: 'region' },
            { text: 'Действия', value: 'actions', sortable: false }
          ]
        },
        'black': {
          data: [],
          pageCount_server:0,
          headers: [
            { text: '№', align: 'start', value: 'id', sortable: false },
            { text: 'Номер', value: 'phone' },
            { text: 'Оператор', value: 'operator' },
            { text: 'Регион', value: 'region' },
            { text: 'Дата создания', value: 'created_at' },
            { text: 'Будет удален', value: 'dead_at' },
            { text: 'Действия', value: 'actions', sortable: false }
          ]
        }
      }

    }
  },
  beforeMount(){
    this.current = this.default
    this.renderBases()
  },
   methods: {
openExportModal(row) {                 
  const guid = typeof row === 'string' ? row : row.guid;
  this.exportGuid = guid;
    this.showExport = true;
},
    deleteLead(item){
      this.$http.post("/base/deletelead", { id: item.guid }, data => {
        this.renderBases()
        return data
      })
    },
    deleteBase(item){
      this.$http.post("/base/delete", { id: item.guid }, data => {
        this.renderBases()
        return data
      })
    },

    returnMain(){
      this.if_main = true
      this.allGuids = [];
      this.reset()
      this.renderBases()
    },

    editBaseEmit(item){
      this.editBase(true,{id:item.guid,item:item})
    },
    editBase(visible,base,edit){

      if (base){
        this.edit_base=base
      }
      if (edit){
        this.renderBases()
      }
      this.edit_popup = visible
    },

    renderBases(filters = false){
      this.loading = true
      if(filters){
        this.filters = filters
      }else{
        filters = this.filters || {}
      }
      if (this.if_main){
        if (filters && filters.startDate && filters.endDate) {
        this.applyBaseFilters()
        this.loading = false
        return
      }
        this.$http.post("/base/list", {filters}, data => {
         
  this.loading = false;
  const groupNames = data.map(item => item.groupName);
  const uniqueGroupnames = [...new Set(groupNames)];
  const clearGroups = uniqueGroupnames.filter(group => group !== undefined);
  this.groups = clearGroups
  this.cases.main.data = data;

  this.basesAll = data
  const names = [...new Set(data.map(b => b.name).filter(Boolean))]
  this.baseSelects.baseNames = names
  this.baseSelects.bases = data
  this.applyBaseFilters()
  
});
      }
      else
      {

        if (!filters){
          filters = this.filters
        }
        filters.blacklist = 0
        if (this.tablist == "black"){
          filters.blacklist = 1
        }

        filters.perPage = this.perPage
        this.filters = filters
        this.$http.post("/base/leads", {
          
          filters: filters,
          id: this.id
        }, data => {
          this.loading = false
          this.cases[this.tablist].data = data.leads
          data.leads.forEach(lead => {
              if (lead.dead_at) {
                  let year = parseInt(lead.dead_at.split('-')[0], 10);
                  if (year >= 2029) {
                      lead.dead_at = "-";
                  }
              }
          });
          this.allGuids = data.ids || [];
          if (data.count) {
            this.cases[this.tablist].pageCount_server = data.count
          }
        })
      }
    },
    applyBaseFilters () {
      let rows = [...this.basesAll]
      const { startDate, endDate,  baseNames,baseGuids } = this.filters || {}
    
      if (startDate && endDate) {
    
        const makeLocalDate = (iso, endOfDay = false) => {
          const [y, m, d] = iso.split('-')
          const time = endOfDay ? '23:59:59' : '00:00:00'
          return new Date(`${y}-${m}-${d}T${time}`)
        }
    
        const from = makeLocalDate(startDate, false)
        const to   = makeLocalDate(endDate,   true)
    
        rows = rows.filter(base => {
          if (!base.created_at) return false
    
          const [d, m, y] = String(base.created_at).split('.')
          if (!y || !m || !d) return false
    
          const created = new Date(`${y}-${m}-${d}T00:00:00`)
    
          return created >= from && created <= to
        })
      }

      if (Array.isArray(baseNames) && baseNames.length) {
      rows = rows.filter(base => baseNames.includes(base.name))
      }
      if (Array.isArray(baseGuids) && baseGuids.length) {
        rows = rows.filter(base => baseGuids.includes(base.guid))
      }
    
      this.cases.main.data = rows
    },
    loadAllIds() {
    this.$http.post("/base/leads", {
      id: this.id,
      filters: { ...this.filters, selectAll: true }
    }, () => {
      this.renderBases({ tab: "all" });
      setTimeout(() => { window.location.reload()},300)
    })
   },
    viewBase(item){
      let guid = item.guid
      let name = item.name
      this.allGuids = [];

      this.id = guid
      this.current.title = name
      this.breadcrumbs[1].text = name
      this.renderBases({tab:"all"})
      this.if_main = false
    },
    reset(){
      this.current.title = "Базы номеров"
    }
  },
}
</script>
<style scoped>
.tabs_table_inner .v-slide-group__content{
  margin: 0 16px;
}
.info-icon {
  position: relative;
  top: -10px;
  cursor: pointer;
}
.item_tab{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #808185;
}
.active_tab{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #2B2D33;
}
  .v-list div
  {
  cursor:pointer;
  }
  .content_table{
    margin-top: 24px;
    border-radius: 8px;
  }
  .content{
    height: 100%;
    display: flex;
    position: relative;
    z-index: 1000;
  }
 .custom-button {
  position: static;
  margin-right: 8px;
}
@media (max-width: 650px) {
  .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .top > .d-flex:last-child {
    width: auto !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

.custom-button {
    width: auto !important;
    align-self: flex-start;
  }
}
  @media (max-width: 400px){
    h1{
      margin-top: 15px;
    }
  }
</style>
